import gql from 'graphql-tag';

export const deleteDevicesMutation = gql`
  mutation ($type: String, $deviceIds: [Int]) {
    deleteDevices(type: $type, deviceIds: $deviceIds)
    {
      rows_deleted
    }
  }
`
